<template>
    <div class="row">
        <div class="col" v-if="isLoading">
            <card>
                 <span slot="header">
                  </span>
                <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']" spin></font-awesome-icon></span></h1>
                <div slot="footer">
                </div>
            </card>
        </div>
        <div class="col-12 mb-2">
            <base-button v-if="!isLoading" type="default" @click="showCreateModal = true" class="right">Add Ringgroup
            </base-button>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4" v-if="!isLoading" v-for="group in ringgroups"
             :key="group.id">
            <card>
                 <span slot="header">
                    {{ group.name }}
                     <span class="right text-success" v-if="!dirty[group.id]">Synced</span>
                     <span class="right text-warning" v-if="dirty[group.id]">Not Saved</span>
                  </span>
                <h4 class="card-title"></h4>
                <base-input
                        :value="group.name"
                        label="Name"
                        required
                        :ref="'input' + group.id"
                        :name="'name-' + group.id"
                        v-validate="'required|min:3|max:50'"
                        @input="handleNameInputChange(group.id,$event)"
                        :error="getError('name-' + group.id)"
                ></base-input>
                <hr>
                <device-number-selector :devices="group.destinations.devices" :numbers="group.destinations.numbers"
                                        v-on:number-add="handleDestinationNumberAdd(group.id)"
                                        v-on:number-remove="handleDestinationNumberRemove(group.id,$event)"
                                        v-on:number-update="handleDestinationNumberUpdate(group.id,$event)"
                                        v-on:device-add="handleDeviceAdd(group.id, $event)"
                                        v-on:device-remove="handleDeviceRemove(group.id, $event)"/>
                <div slot="footer">
                    <div class="row">
                        <div class="col">
                            <base-button class="left" :loading="saving[group.id]" :disabled="!dirty[group.id]"
                                         @click="save(group.id)" type="primary">
                                Save
                            </base-button>

                            <base-button icon @click="remove(group.id)" type="danger" :loading="removing[group.id]"
                                         class="right">
                                <i v-if="!removing[group.id]" class="fal fa-trash"></i>
                            </base-button>

                        </div>
                    </div>

                </div>
            </card>
        </div>

        <new-ringgroup-modal v-on:update-show="updateShow" v-on:created="created"
                             :show.sync="showCreateModal"></new-ringgroup-modal>
    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";
    import {Autocomplete, Tag, Tooltip} from 'element-ui';
    import NewRinggroupModal from "./NewRinggroupModal";
    import DeviceNumberSelector from "./DeviceNumberSelector";
    import swal from 'sweetalert2';

    export default {
        name: "RinggroupsTable",
        components: {
            DeviceNumberSelector,
            NewRinggroupModal,
            [Tag.name]: Tag,
            [Autocomplete.name]: Autocomplete,
            [Tooltip.name]: Tooltip
        },
        computed: {
            ...mapFields(`sipdevice`, ['sipdevices']),
            ...mapFields(`ringgroup`, ['ringgroups']),
        },
        data() {
            return {
                isLoading: false,
                inputVisible: false,
                inputValue: [],
                dirty: [],
                saving: [],
                removing: [],
                names: [],
                showCreateModal: false,
            };
        },
        methods: {
            updateShow(value) {
                this.showCreateModal = value;
            },
            created() {
                this.loadRinggroups();
            },
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            handleDestinationNumberAdd(id) {
                this.$store.commit('ringgroup/ADD_RINGGROUP_NUMBER', id);
                this.$set(this.dirty, id, true)
            },
            handleDestinationNumberUpdate(id, event) {
                let number = event.number;
                let nIndex = event.nIndex;
                this.$store.commit('ringgroup/UPDATE_RINGGROUP_NUMBER', {id, nIndex, number});
                this.$set(this.dirty, id, true)
            },
            handleDestinationNumberRemove(id, event) {
                let number = event.number;
                this.$store.commit('ringgroup/REMOVE_RINGGROUP_NUMBER', {id, number});
                this.$set(this.dirty, id, true)
            },
            reset() {
                this.loadRinggroups();
            },
            save(id) {
                this.$set(this.saving, id, true);
                let data = this.$store.getters['ringgroup/getById'](id);
                this.$store.dispatch('ringgroup/save', {data, id}).then(() => {
                    this.$set(this.saving, id, false);
                    this.$notify({
                        verticalAlign: 'bottom',
                        horizontalAlign: 'right',
                        message: 'Your ringgroup: ' + data.name + ' was saved!',
                        type: "success",
                        icon: "fal fa-save",
                        title: "Saved!"
                    });

                    this.$set(this.dirty, id, false);
                    this.names[id] = this.$store.getters['ringgroup/getById'](id).name;
                }).catch(() => {
                    this.$set(this.saving, id, false);
                    this.$notify({
                        position: "bottom-right",
                        message: 'Your ringgroup: ' + data.name + ' failed to save!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                });
            },
            handleNameInputChange(id, value) {
                let name = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
                this.$store.commit('ringgroup/UPDATE_RINGGROUP_NAME', {id, name});
                this.$set(this.dirty, id, true);
            },
            loadRinggroups() {
                this.isLoading = true;
                this.$store.dispatch('ringgroup/load').then(() => {
                    this.localRinggroups = this.ringgroups;
                    this.dirty = [];
                    this.names = [];
                    this.saving = [];
                    this.localRinggroups.forEach(g => {
                        this.$set(this.dirty, g.id, false);
                        this.names[g.id] = (g.name);
                        this.$set(this.saving, g.id, false);
                    });
                    this.isLoading = false;
                })
            },
            remove(id) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.$set(this.removing, id, true);
                        this.$store.dispatch('ringgroup/remove', {id}).then(() => {
                            this.$notify({
                                verticalAlign: 'bottom',
                                horizontalAlign: 'right',
                                message: 'Your ringgroup was removed!',
                                type: "success",
                                icon: "fal fa-trash",
                                title: "Removed!"
                            });

                            this.$set(this.dirty, id, false);
                            this.$set(this.saving, id, false);
                            this.$set(this.removing, id, false);
                            this.names[id] = this.$store.getters['ringgroup/getById'](id).name;
                            this.loadRinggroups();
                        });
                    }
                });
            },
            handleDeviceAdd(id, event) {
                let device = event.device;
                this.$store.commit('ringgroup/ADD_RINGGROUP_DEVICE', {id, device});
                this.$set(this.dirty, id, true);
            },
            handleDeviceRemove(id, event) {
                let name = event.name;
                this.$store.commit('ringgroup/REMOVE_RINGGROUP_DEVICE', {id, name});
                this.$set(this.dirty, id, true);
            }
        },
        mounted() {
            if (this.$store.getters['sipdevice/needUpdate']) {
                this.$store.dispatch('sipdevice/loadSIPDevices');
            }
            if (this.$store.getters['ringgroup/needUpdate']) {
                this.loadRinggroups();
            }
        },
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }
</style>
